const TOKEN_ADDRESSES = {
  DRIP: "0x20f663CEa80FaCE82ACDFA3aAE6862d246cE0333",
};

export default TOKEN_ADDRESSES;
